(function() {
  'use strict';

  // Le moteur chargé par le layout porte les règles communes à la fiche et au panier.
  /* i18n R2b. Table de chaines lue UNE fois, avec repli code : voir
     CONVENTION.md § 3. Une zone pas encore remplie reste `{}`. */
  var S = (window.FoxTheme && window.FoxTheme.casemira && window.FoxTheme.casemira.fiche) || {};

  function avec(modele, jeton, valeur) {
    return String(modele).split(jeton).join(valeur);
  }

  /* Les noms de jour et de mois viennent de la LOCALE DE LA PAGE, jamais d'un
     tableau code en dur (CONVENTION.md § 6). Meme source que
     assets/casemira-collection-plus.js. */
  var LOCALE = document.documentElement.lang
            || (window.Shopify && window.Shopify.locale)
            || 'fr-FR';
  var FMT_DATE, FMT_JOUR;
  try {
    FMT_DATE = new Intl.DateTimeFormat(LOCALE, { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
    FMT_JOUR = new Intl.DateTimeFormat(LOCALE, { timeZone: 'UTC', weekday: 'long' });
  } catch (e) {
    FMT_DATE = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
    FMT_JOUR = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', weekday: 'long' });
  }

  /* Jour a l'accusatif (lt, remarque de Daniel du 12/10) : apres « išsiųsime » et
     dans la date de livraison, le lituanien veut « antradienį » ; Intl rend le
     nominatif « antradienis ». La cle casemira.fiche.jours_accusatif porte les
     sept noms dans l'ordre de getUTCDay() (les formats sont en UTC). Cle absente
     ou mal formee, donc toutes les autres langues : sortie d'Intl inchangee. */
  var JOURS_ACC = String(S.joursAccusatif || '').split(',').map(function(j){ return j.trim(); });
  if (JOURS_ACC.length !== 7 || JOURS_ACC.some(function(j){ return !j; })) JOURS_ACC = null;

  function formatJour(fmt, d){
    if (!JOURS_ACC || !fmt.formatToParts) return fmt.format(d);
    return fmt.formatToParts(d).map(function(p){
      return p.type === 'weekday' ? JOURS_ACC[d.getUTCDay()] : p.value;
    }).join('');
  }

  function formatDate(d){
    return formatJour(FMT_DATE, d);
  }

  function pad(n){ return (n<10?'0':'')+n; }

  /* 14/10/2026 · LA DATE AFFICHÉE PART AVEC LA LIGNE DE PANIER, pour le mail de
     confirmation (snippets/casemira-proprietes-ligne.liquid). Les champs cachés du
     produit de ce bloc reçoivent les valeurs mêmes qui viennent d'être écrites :
     livraison et expédition en ISO (les dates du moteur sont des minuits UTC), pays du
     calcul. Ils sont activés ici, et seulement ici : sans ce script, ils ne partent pas. */
  function iso(d){ return d.toISOString().slice(0, 10); }

  function poseLigne(el, estimate, pays){
    var produit = el.getAttribute('data-delivery-product');
    var valeurs = { promise: iso(estimate.deliveryDate), expedie: iso(estimate.dispatchDate), pays: pays };
    var champs = document.querySelectorAll('input[data-cm-livraison]');
    for (var i = 0; i < champs.length; i++) {
      var champ = champs[i];
      var v = valeurs[champ.getAttribute('data-cm-livraison')];
      if (!v || champ.getAttribute('data-cm-produit') !== produit) continue;
      champ.value = v;
      champ.disabled = false;
    }
  }

  function update(){
    var el = document.getElementById('dc-block');
    var elDate = document.getElementById('dc-date-text');
    var elTimerRow = document.getElementById('dc-timer-row');
    var elTimer = document.getElementById('dc-timer-text');
    var elShip = document.getElementById('dc-ship-text');
    if(!el) return;

    if (!window.CasemiraDelivery) return;
    var pays = window.CasemiraDelivery.currentCountry();
    var estimate = window.CasemiraDelivery.estimate({
      country: pays,
      vendor: el.getAttribute('data-delivery-vendor')
    });
    var shipDate = estimate.dispatchDate;
    elDate.textContent = formatDate(estimate.deliveryDate);
    poseLigne(el, estimate, pays);
    var diffMs = estimate.countdownMs;
    var diffHours = diffMs / 3600000;

    if (diffMs > 0 && diffHours <= 24) {
      var totalMin = Math.floor(diffMs / 60000);
      var hrs = Math.floor(totalMin / 60);
      var mins = totalMin % 60;
      elTimer.textContent = hrs > 0 ? (hrs + 'h ' + pad(mins) + 'min') : (mins + 'min');

      // Libellé relatif : aujourd'hui / demain / sinon le jour
      var dayDiff = estimate.dispatchDayOffset;
      var shipLabel = dayDiff <= 0 ? (S.aujourdhui || 'aujourd’hui')
                    : (dayDiff === 1 ? (S.demain || 'demain')
                    : formatJour(FMT_JOUR, shipDate));
      elShip.textContent = avec(S.expedie || 'expédié [quand]', '[quand]', shipLabel);

      elTimerRow.style.display = 'block';
    } else {
      elTimerRow.style.display = 'none';
    }

    el.style.display = 'flex';
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){update();clearInterval(window.casemiraDeliveryTimer);window.casemiraDeliveryTimer=setInterval(update,30000);});
  } else {
    update();clearInterval(window.casemiraDeliveryTimer);window.casemiraDeliveryTimer=setInterval(update,30000);
  }
})();
